const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInlaosantipap',
    accessToken: 'accessTokenlaosantipap',
    userRole: 'userRole',
  }
}

export default AppConfig;
